export const defaultLocale = 'ja' as const;

export const locales = ['en', 'ja'] as const;

export const languageNames = {
  en: 'English',
  ja: '日本語',
};
